import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = { class: "card-data" }
const _hoisted_3 = { class: "main-page-feature" }
const _hoisted_4 = { class: "feature-title" }
const _hoisted_5 = { class: "feature-sub-title" }
const _hoisted_6 = { class: "main-page-content" }
const _hoisted_7 = { class: "main-page-text" }
const _hoisted_8 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "report-page-card top-right-color-triangle",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "top-triangle" }, [
          _createElementVNode("div", { class: "top-right-color-triangle" }),
          _createElementVNode("div", { class: "top-right-grey-triangle" })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.title), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.data.subTitle), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "main-page-content-title" }, "Introduction and Context", -1)),
            _createElementVNode("div", _hoisted_7, " This report has been prepared for " + _toDisplayString(_ctx.data.title) + ". The data received from " + _toDisplayString(_ctx.data.title) + " has assisted AgeWage to calibrate returns against a benchmark that can be used to analyse all individual DC pension pots and satisfy the Work and Pensions Select Committee's recent call for a common definition of value for money. AgeWage intends to create a universe of scheme scores for employer sponsored and multiemployer sponsored workplace schemes. The output of this report covers both the AgeWage score (a common measure of value for money) and a data quality score. By agreeing to be part of the AgeWage benchmarking program, you will get a score for your scheme and a data quality score. These scores will appear on charts which explain how your VFM and data quality compare with your peers. ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}